var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range"},[_c('p',{staticClass:"xq"},[_c('span',{staticClass:"xq_1"},[_vm._v("离你最近的校区")]),_vm._v(" "),_vm._l((_vm.areaCityPoint),function(area){return _c('a',{staticClass:"range_xq",attrs:{"href":_vm.areaCityPointURL(_vm.schoolID,area.Code)}},[_vm._v(_vm._s(area.Name))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0d0731a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/NearCampus.vue
// module id = 358
// module chunks = 0 1 2